"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonNonDOMPropTypes = exports.buttonBasePropTypes = exports.ButtonBase = void 0;
var _react = require("react");
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _context = require("../context");
var _utils2 = require("../utils");
var _constants = require("./constants");
var _interfaces = require("./interfaces");
var _typographyStyles = require("./typographyStyles");
var _variantStyles = require("./variantStyles");
const buttonBasePropTypes = exports.buttonBasePropTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Displayed inside the clickable area of the button.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the button from being clicked.'),
  'aria-disabled': _stencilReactDesc.PropTypes.bool.description('Prevents the button from being clicked, but allows putting focus.')
};
const buttonNonDOMPropTypes = exports.buttonNonDOMPropTypes = {
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ButtonColorScheme)).description('Selects a predefined color scheme to use for the component.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon on the leading or trailing side of the button.'),
  iconPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ButtonIconPosition)).description('Determines on which side the icon would be placed.'),
  isDestructive: _stencilReactDesc.PropTypes.bool.description('Change the style of the button to indicate that it performs a destructive action.'),
  shouldUseResponsiveContent: _stencilReactDesc.PropTypes.bool.description("Indicates whether the button's content parameters ('padding', 'font-size', 'line-height') should be changing based on the breakpoints in the theme.").deprecated('This property is deprecated, and will not be supported after 5.x.'),
  size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ButtonSize)).description('Specifies what size of the button should be used.'),
  variant: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ButtonVariant)).description('The type of button that determines its visual style.')
};
const ButtonBase = exports.ButtonBase = (0, _context.styledWithTheme)('button', {
  shouldForwardProp: (0, _utils2.filterPropsFromPropTypes)(buttonNonDOMPropTypes, {
    filterInvalidHTML: true
  })
})(_ref => {
  let {
    ...props
  } = _ref;
  // Keep disabled styling even if only aria-disabled passed
  let isAriaDisabled = false;
  if (props['aria-disabled'] && !props.disabled) {
    props.disabled = true;
    isAriaDisabled = true;
  }
  const {
    shouldUseResponsiveContent,
    disabled: isDisabled
  } = props;
  (0, _react.useEffect)(() => {
    if (shouldUseResponsiveContent) {
      (0, _utils2.showDeprecationWarning)({
        deprecatedName: 'shouldUseResponsiveContent prop',
        docsLink: 'https://docs.stencil.a2z.com/components/button?tab=implementation',
        version: '5.x'
      });
    }
  }, [shouldUseResponsiveContent]);
  return {
    ...(0, _variantStyles.getVariantStyles)(props),
    ...(0, _typographyStyles.typographyStyles)(props),
    alignItems: 'center',
    borderStyle: 'solid',
    borderWidth: "".concat(_constants.BORDER_WIDTH, "px"),
    boxShadow: 'none',
    boxSizing: 'border-box',
    cursor: !!props.disabled ? 'not-allowed' : 'pointer',
    fontFamily: (0, _utils.token)('text.family.default'),
    fontWeight: (0, _utils.token)('text.weight.medium'),
    justifyContent: 'center',
    position: 'relative',
    textAlign: 'center',
    transition: 'background-color .2s ease 0s, border-color .2s ease 0s',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    ...(isAriaDisabled && {
      color: _constants.ARIA_DISABLED_TEXT_COLOR
    }),
    ...(0, _utils2.getHighContrastModeStyles)({
      color: isDisabled ? _utils2.WHCM_DISABLED_ITEM_COLOR : _utils2.WHCM_BUTTON_COLOR,
      borderColor: isDisabled ? _utils2.WHCM_DISABLED_ITEM_COLOR : _utils2.WHCM_BUTTON_COLOR
    })
  };
});